import React, { useEffect, useState, useRef } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import "./BookingSuccess.css";
import { FaStar, FaHeart } from "react-icons/fa";
import Button from "@material-ui/core/Button";
import celebrationImage from "../images/celebration-woman.png";
import MyYuukke from "../api/MyYuukke";

const BookingSuccess = () => {
  const history = useHistory();
  const { orderId } = useParams(); // ✅ GET FROM PATH

  const [status, setStatus] = useState("checking"); 
  // checking | success | pending | failed

  const calledRef = useRef(false);
  const retryRef = useRef(0);

  

  // ✅ PAYMENT VERIFY LOGIC
  useEffect(() => {
    console.log("Verifying payment for orderId:", orderId); 
    if (!orderId || calledRef.current) return;

    calledRef.current = true;

    MyYuukke.paymentVerify({ "orderId" : orderId })
      .then((res) => {
        const paymentStatus = res?.data?.status;

        if (paymentStatus === "SUCCESS") {
          setStatus("success");
        } else if (paymentStatus === "FAILED") {
          setStatus("failed");
        } else {
          setStatus("pending");
        }
      })
      .catch(() => {
        setStatus("pending");
      });
  }, [orderId]);

  // ✅ AUTO-RETRY WHEN PENDING
  useEffect(() => {
    if (status !== "pending") return;
    if (retryRef.current >= 5) return;

    const t = setTimeout(() => {
      retryRef.current += 1;
      calledRef.current = false;
      setStatus("checking");
    }, 5000);

    return () => clearTimeout(t);
  }, [status]);

  // const goToBookings = () => history.push("/my-bookings");

  return (
    <div className="bs-page">
      <div className="bs-top-border" />

      <div className="bs-layout">
        {/* LEFT IMAGE */}
        <div className="bs-image-wrapper">
          <div className="bs-image-frame">
            <img src={celebrationImage} alt="Celebration" className="bs-image" />
            <div className="bs-image-badge">
              <FaStar style={{ marginRight: 6 }} />
              VIP Confirmed
            </div>
          </div>
        </div>

        {/* RIGHT CONTENT */}
        <div className="bs-right">
          <div className="bs-badge-circle">
            <div className="bs-badge-ring">
              <div className="bs-badge-inner">
                {status === "success" && "✔"}
                {(status === "checking" || status === "pending") && "⏳"}
                {status === "failed" && "✖"}
              </div>
            </div>
          </div>

          <div className="bs-content">
            {status === "checking" && (
              <>
                <h1 className="bs-title">Checking Payment…</h1>
                <p className="bs-subtitle">
                  Please wait while we confirm your payment
                </p>
              </>
            )}

            {status === "success" && (
              <>
                <h1 className="bs-title">
                  Booking <br /> Successful!
                </h1>
                <p className="bs-subtitle">
                  Your payment is confirmed and booking is completed.
                </p>
              </>
            )}

            {status === "pending" && (
              <>
                <h1 className="bs-title">Payment Processing</h1>
                <p className="bs-subtitle">
                  We are waiting for confirmation from the bank.
                  This may take a minute.
                </p>
              </>
            )}

            {status === "failed" && (
              <>
                <h1 className="bs-title">Payment Failed</h1>
                <p className="bs-subtitle">
                  We could not confirm your payment. Please contact support.
                </p>
              </>
            )}

            <div className="bs-tagline">
              <FaHeart className="bs-heart" />
              <span>Thank you for choosing Yuukke</span>
            </div>

            {/* <div className="bs-actions">
              {status === "success" && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={goToBookings}
                >
                  View My Bookings
                </Button>
              )}
            </div> */}

            <div className="bs-footer-text">
              <span className="bs-dot" />
              <span>Order ID: {orderId}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingSuccess;
